// The tabs of Parties & Ledger (pages/Parties.js).
//
// Party Master and Party Ledger were two sidebar entries about the same people —
// one held their details, the other held their money — so working a party meant
// leaving one screen to look at the other. They are one page with tabs now.
//
// This list lives apart from the page because two places need it and they must not
// drift: the page decides which tab to render, and Layout decides whether the single
// nav entry is worth showing at all. The flags are independent — a tenant can have
// the ledger on with the master off — so the nav entry is gated on `anyOf` these
// rather than on any one of them.
//
// `moduleKey` / `featureCode` are the same pair a nav item carries, so each tab is
// gated exactly as its old sidebar entry was (see hooks/useNavVisibility). Agents
// deliberately carries no moduleKey: it has always been an open tab of the party
// master rather than a destination of its own, and merging the ledger in is not a
// reason to start taking it away from anybody.
const PARTY_WORKSPACE_TABS = [
  { key: 'parties', label: 'Parties', moduleKey: 'parties', featureCode: 'parties' },
  { key: 'ledger', label: 'Party Ledger', moduleKey: 'partyLedger', featureCode: 'partyLedger' },
  { key: 'agents', label: 'Agents' },
  { key: 'graders', label: 'Graders', moduleKey: 'parties', featureCode: 'graderAssessment' },
];

export default PARTY_WORKSPACE_TABS;
